module.exports = __webpack_public_path__ + "img/ch64.5ce3af98.jpg";